<template>
  <div class="details">
    <div class="details-info">
      <div class="details-info-title">{{ info.couponName }}</div>
      <div class="details-info-type">服务券类型：{{ info.couponTypeName }}</div>
      <div class="details-info-type">使用时间：{{ info.useTime || '-' }}</div>
      <div class="details-info-type">
        领取时间：{{ info.createTime || '-' }}
      </div>
      <div
        class="details-info-status"
        :class="{ 'details-info-status1': info.useStatus == 2 }"
        v-if="info.useStatusText"
      >
        {{ info.useStatusText }}
      </div>
    </div>
    <div class="total">
      <div class="total-list">
        <div class="total-list-title">总金额</div>
        <div class="total-list-num">
          ￥<span>{{ info.totalAmount }}</span>
        </div>
      </div>
      <div class="total-list">
        <div class="total-list-title">剩余金额</div>
        <div class="total-list-num">
          ￥<span>{{ info.restAmount }}</span>
        </div>
      </div>
      <div class="total-list">
        <div class="total-list-title">使用金额</div>
        <div class="total-list-num">
          ￥<span>{{ info.useAmount }}</span>
        </div>
      </div>
    </div>
    <div class="use" v-if="lists.length > 0">
      <div class="use-title">使用情况</div>
      <div class="use-list">
        <div class="use-list-box" v-for="(item, i) in lists" :key="i">
          <div class="use-list-box-title">
            <van-image
              class="use-list-box-title-icon"
              fit="contain"
              :src="require('../../../assets/coupons-icon.png')"
            />
            <span>{{ item.goodsOrg }}</span>
          </div>
          <div class="use-list-box-main">
            <van-image
              class="use-list-box-main-img"
              fit="cover"
              :src="item.goodsOssUrl"
            />
            <div class="use-list-box-main-info">
              <div class="use-list-box-main-info-price">
                -￥<span>{{ item.deductionPrice }}</span>
              </div>
              <div class="use-list-box-main-info-name">
                商品名称：{{ item.goodsName }}
              </div>
              <div class="use-list-box-main-info-time">
                使用时间：{{ item.entConfirmTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { entCouponDetail } from '@api/coupons/index'
import { Toast } from 'vant'
export default {
  data() {
    return {
      info: {
        useStatus: 0,
        useStatusText: '',
        couponName: '',
        couponTypeName: '',
        useTime: '',
        createTime: '',
        totalAmount: '',
        restAmount: '',
        useAmount: ''
      },
      lists: []
    }
  },
  mounted() {
    entCouponDetail({ id: this.$route.query.id }).then(res => {
      const { code, data, msg } = res.data
      if (code === '0000') {
        let useStatusText = ''
        switch (data.useStatus) {
          case 0:
            useStatusText = '未开始'
            break
          case 2:
            useStatusText = '已过期'
            break
        }
        this.info = data
        this.info.totalAmount = (data.totalAmount || 0)
          .toString()
          .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        this.info.restAmount = (data.restAmount || 0)
          .toString()
          .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        this.info.useAmount = (data.useAmount || 0)
          .toString()
          .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        this.info.useStatusText = useStatusText
        if (data.couponStartTime && data.couponEndTime) {
          this.info.useTime =
            data.couponStartTime.split(' ')[0] +
            '至' +
            data.couponEndTime.split(' ')[0]
        }
        this.lists = data.orderRecordList
      } else {
        Toast(msg)
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.details {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  overflow: hidden;
}
.details-info {
  width: 100%;
  background: #fff;
  padding: 15px;
  position: relative;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  &-title {
    font-size: 18px;
    font-weight: bold;
  }
  &-type {
    font-size: 14px;
    color: #999;
    margin-top: 10px;
  }
  &-status {
    background: #ff9900;
    color: #fff;
    font-size: 10px;
    padding: 4px 50px;
    text-align: center;
    position: absolute;
    top: 10px;
    right: -46px;
    transform: rotate(45deg);
  }
  &-status1 {
    background: #ff6600;
  }
}
.total {
  background: #fff;
  padding: 12px 0;
  display: flex;
  &-list {
    flex: 1;
    padding: 0 15px;
    border-right: 1px solid #eee;
    &-title {
      font-size: 12px;
      color: #999;
    }
    &-num {
      font-size: 12px;
      color: #999;
      margin-top: 8px;
      span {
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
    }
  }
}
.use {
  padding: 15px;
  &-title {
    font-size: 15px;
    color: #888;
  }
  &-list {
    &-box {
      margin-top: 10px;
      background: #fff;
      &-title {
        padding: 10px 15px;
        border-bottom: 1px solid #eee;
        &-icon {
          width: 20px;
          vertical-align: middle;
          color: #005bff;
        }
        span {
          font-size: 16px;
          font-weight: bold;
          margin-left: 10px;
        }
      }
      &-main {
        display: flex;
        overflow: hidden;
        padding: 15px 15px;
        &-img {
          width: 90px;
          height: 80px;
        }
        &-info {
          flex: 1;
          overflow: hidden;
          padding-left: 10px;
          &-price {
            font-size: 14px;
            span {
              font-size: 18px;
              color: #333;
              font-weight: bold;
            }
          }
          &-name {
            font-size: 14px;
            color: #999;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &-time {
            font-size: 14px;
            color: #999;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
